import styled from 'styled-components';

import { theme } from '@util/theme';
import { pixelToRem } from '@util/commonStyles';

export const ModalWrap = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
`;
export const ModalBox = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${pixelToRem(60)} ${pixelToRem(100)};
  background: ${theme.background.white};
`;
export const ModalText = styled.h1`
  font-size: ${pixelToRem(20)};
  font-weight: bold;
  margin-bottom: ${pixelToRem(50)};
`;
